import { userService } from '../../services'
import router from '../../router'

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user ? { status: { loggedIn: true }, user } : { status: {}, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ dispatch, commit }, { username, password, redirect }) {
      commit('loginRequest', { username });

      userService.login(username, password)
        .then(
          user => {
            commit('loginSuccess', user);
            router.push(redirect || '/shop');
          },
          error => {
            console.error(error)
            let displayError
            let { response } = error
            if (response && response.data && response.data.error) {
              displayError = response.data.error
            } else {
              displayError = error.toString()
            }

            //let displayError = error.response.data.error || error
            commit('loginFailure', error);
            dispatch('alert/error', displayError, { root: true });
          }
        );
    },
    register({ dispatch, commit }, { name, email, phone, password, token, redirect }) {
      commit('registerRequest', user);
      // if(!token) {}
      let targetFn = !token ? userService.registerUser : userService.register
      console.log(`registering user`)
      targetFn({ name, email, password, phone, token })
        .then(
          user => {
            commit('registerSuccess', user);
            router.push(redirect || '/shop')
          },
          error => {
            console.error(error)
            let displayError
            let { response } = error
            if (response && response.data && response.error) {
              displayError = response.data.error
            } else {
              displayError = error.toString()
            }
            commit('loginFailure', error)
            dispatch('alert/error', displayError, { root: true })
          }
        )

    },
    // verfies auth and sets user info
    fetchUser({ dispatch, commit }) {
      userService.userInfo()
        .then(
          info => {
            commit('userInfo', info)
            if (info) {
              let intercomOpts = {
                user_id: info.uuid,
                name: info.name,
                email: info.email,
                phone: info.phone,
              }
              console.log(intercomOpts)
              this._vm.$intercom.boot(intercomOpts)
            }
          },
          error => {
            console.error(error)
          }
        )
    },
    logout({ commit }) {
      userService.logout();
      commit('logout');
    }
  },
  mutations: {
    userInfo(state, info) {
      // if (!state.user) return console.error('no user to commit userInfo to')
      if (!state.user) {
        let lsUser = localStorage.getItem('user')
        if (lsUser) { state.user = JSON.parse(lsUser) } else {
          state.user = {}
        }
      }
      state.user.info = info
    },
    registerRequest(state, user) {
      state.status = { registering: true };
    },
    registerSuccess(state, user) {
      state.status = {};
      state.user = user
    },
    registerFailure(state, error) {
      state.status = {};
    },
    loginRequest(state, user) {
      state.status = { loggingIn: true };
      state.user = user;
    },
    loginSuccess(state, user) {
      state.status = { loggedIn: true };
      state.user = user;
    },
    loginFailure(state) {
      state.status = {};
      state.user = null;
    },
    logout(state) {
      state.status = {};
      state.user = null;
    }
  }
}